module.exports = __webpack_public_path__ + "static/media/Sliny.15afbf14.md";